<template>

</template>

<script>
export default {
  name: "test",
  created() {
    window.location.href = window.location.protocol + '//' + window.location.host + '/#/' + '?ccid=' + this.$route.query.ccid + '&ggid=' + this.$route.query.ggid + '&person=' + this.$route.query.person
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bounce_back.vue